const observer = document.querySelector('.newsletter-popup')
    && ('MutationObserver' in window)
    && new window.MutationObserver(onNewsletterPopup)

if (observer)
    observer
        .observe(document.body, {
            childList: true
        })

function onNewsletterPopup () {
    const widget = Array.from(document.body.children)
        .filter(el => el.getAttribute('widgetid')
            || (el.id || '').match(/^Popup/))[0]

    if (!widget)
        return

    observer.disconnect()

    widget.style.visibility = 'hidden'

    const iframes = Array.from(widget.querySelectorAll('iframe'))
        .filter(el => el.contentDocument)

    iframes
        .forEach((el) => {
            Array
                .from(el.contentDocument.querySelectorAll('input[type=email]'))
                .filter(el => !el.getAttribute('placeholder'))
                .forEach(el => el.setAttribute('placeholder', 'Email address'))

            const typekit = el.contentDocument.createElement('link')

            typekit.rel = 'stylesheet'
            typekit.href = 'https://use.typekit.net/opf4dtx.css'

            const head = el.contentDocument.querySelector('head')

            head.appendChild(typekit)

            const style = el.contentDocument.createElement('style')
            style.type = 'text/css'

            style.innerHTML = `
                @font-face {
                    font-style: normal;
                    font-family: 'GrotzecHead';
                    font-display: 'swap';
                    src: url('/fonts/GrotzecCond-Regular.woff2') format('woff2'),
                        url('/fonts/GrotzecCond-Regular.woff') format('woff');
                }

                @font-face {
                    font-style: normal;
                    font-family: 'GrotzecBold';
                    font-display: 'swap';
                    src: url('/fonts/GrotzecCond-Demibold.woff2') format('woff2'),
                        url('/fonts/GrotzecCond-Demibold.woff') format('woff');
                }

                html,
                body {
                    font-family: 'adelle-sans', "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.44;
                    letter-spacing: normal;
                }

                * {
                    font-family: inherit !important;
                }

                .strictContent h1,
                .strictContent h2,
                .strictContent h3,
                .strictContent h4,
                .bannerContent__description,
                h5,
                h6,
                .button {
                    font-family: GrotzecHead !important;
                    font-weight: normal;
                    font-stretch: condensed;
                    font-style: normal;
                    letter-spacing: normal;
                }

                .strictContent h1,
                .strictContent h2,
                .strictContent h3,
                .strictContent h4,
                .bannerContent__description {
                    font-size: 25px;
                    line-height: 1.04;
                }

                .button {
                    letter-spacing: 0.8px;
                    border-radius: 0 !important;
                    line-height: 1;
                    padding: 0 30px;
                    transition: background 200ms;
                    font-size: 13px !important;
                }

                .button:not(:focus-visible) {
                    outline: none !important;
                }

                .modalContent .button {
                    font-size: 16px !important;
                    min-height: 45px;
                }

                .content__button {
                    height: auto;
                    min-height: 36px;
                }

                label {
                    color: #797878;
                    font-size: 14px;
                    font-family: GrotzecBold!important;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    letter-spacing: normal;
                    line-height: 1.14;
                }

                .invalid-error {
                    color: #e03c31;
                    padding-top: 5px;
                }

                select,
                textarea,
                input[type="text"],
                input[type="datetime"],
                input[type="datetime-local"],
                input[type="date"],
                input[type="month"],
                input[type="time"],
                input[type="week"],
                input[type="number"],
                input[type="email"] {
                    border-width: 1px;
                    border-color: #BABABA;
                    border-radius: 0 !important;
                    outline: none !important;
                    line-height: normal;
                    min-height: 45px;
                    padding: 0;
                    text-indent: 14px;
                    font-size: 14px;
                }

                input.invalid:not(:focus) {
                    border-color: #e03c31;
                }

                input::placeholder {
                    color: #A3A3A3;
                }

                .modalContent__content {
                    padding: 60px 40px;
                }

                .modalContent--mobile .modalContent__content {
                    padding-left: 25px;
                    padding-right: 25px;
                }

                @media (min-width: 641px) {
                    .modalContent--mobile .modalContent__content {
                        padding-left: 50px;
                        padding-right: 50px;
                    }
                }

                .modalContent__content,
                .modalContent__content form {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                .modalContent__content form {
                    flex-grow: 1;
                }

                .modalContent__content form > * {
                    margin-top: auto;
                    margin-bottom: auto;
                }

                .modalContent__content form > *:last-child {
                    margin-bottom: 0;
                }

                .content__titleDescription {
                    margin-top: 0;
                }

                .modalContent--mobile .content__titleDescription {
                    margin-top: 20px;
                }

                .modalContent--mobile .content__titleDescription h3 {
                    margin-bottom: 30px;
                }

                .content__formFields .email-field {
                    margin-bottom: 0;
                }

                .modalContent--mobile .content__formFields .email-field {
                    margin-bottom: 20px;
                }

                .content__footer p:empty {
                    display: none;
                }

                .bannerContent {
                    margin-bottom: 0;
                    padding: 20px 25px;
                }

                .bannerContent__closeButton {
                    top: 22.5px;
                    right: 17px;
                }

                @media (min-width: 640px) {
                    .bannerContent {
                        padding-left: 50px;
                        padding-right: 50px;
                    }

                    .bannerContent__closeButton {
                        right: 40px;
                    }
                }
            `

            head.appendChild(style)

            let onResizeDebounced

            window
                .addEventListener('resize', () => {
                    if (onResizeDebounced)
                        clearTimeout(onResizeDebounced)

                    onResizeDebounced = setTimeout(() => {
                        const iframeContent
                            = el.contentDocument.body.children[0]

                        if (!iframeContent
                                || el.clientHeight <= iframeContent.clientHeight)
                            return

                        el.style.height
                            = `${iframeContent.clientHeight}px`
                    }, 200)
                })
        })

    widget.style.visibility = ''
}
